var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.06626 8.81494L4.66992 18.8249H27.4882L29.8769 8.81494H7.06626Z",
    stroke: "#24293D",
    strokeWidth: 0.6,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.81543 18.8252V27.6067",
    stroke: "#24293D",
    strokeWidth: 0.6,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2744 21.7144H10.5166V25.2406H18.2744V21.7144Z",
    stroke: "#24293D",
    strokeWidth: 0.6,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6123 21.7144H20.4121V25.2406H23.6123V21.7144Z",
    stroke: "#24293D",
    strokeWidth: 0.6,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4648 20.3569V27.6066",
    stroke: "#24293D",
    strokeWidth: 0.6,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6064 20.3569V27.6066",
    stroke: "#24293D",
    strokeWidth: 0.6,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.122 19.2953H32.1513L29.5654 8.55732L30.4906 8.3374L33.122 19.2953Z",
    fill: "#24293D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1484 27.6066V21.7144H30.9154V27.6066",
    stroke: "#24293D",
    strokeWidth: 0.6,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6715 28.5317L29.5502 29.0626L29.4592 29.4797H5.48828L5.7082 28.5317H29.6715Z",
    fill: "#24293D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2137 28.5317L34.0924 29.0626L34.0014 29.4797H30.3311L30.551 28.5317H34.2137Z",
    fill: "#24293D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.0684f88b94fb172a27e20700011a64f9.svg";
export { ForwardRef as ReactComponent };